import { CustomerProjectTypeModelType } from '@teinor/erp/types/company/customer/customerProjectType'
import { CustomerProjectStatusModelType } from '@teinor/erp/types/company/customer/customerProjectStatus'
import { projectTypesInversed, ProjectTypesInversedKeys} from '@teinor/erp/types/company/customer/customerProject'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'

export interface CustomerProjectTypesAction {
    type: 'CHANGE_CUSTOMER_PROJECT_TYPES'
    payload: CustomerProjectTypeModelType[]
}

interface CustomerProjectTypeModelTypeExtended extends CustomerProjectTypeModelType {
    customerProjectStatusDict: ProjectStatusTypesParsed
    CustomerProjectStatusesByType: Record<ProjectTypesInversedKeys, CustomerProjectStatusModelType[]>
}

type DictionaryCustomerProjectStatus = { [id: number]: CustomerProjectStatusModelType }
export interface ProjectStatusTypesParsed {
    allStatus: DictionaryCustomerProjectStatus
    opportunity: DictionaryCustomerProjectStatus
    project: DictionaryCustomerProjectStatus
}
export type DictionaryCustomerProject = { [id: number]: CustomerProjectTypeModelTypeExtended }
export type CustomerProjectTypePayload = null | DictionaryCustomerProject

export default function customerProjectTypes(state: CustomerProjectTypePayload = null, action: CustomerProjectTypesAction): DictionaryCustomerProject | null {
    switch (action.type) {
        case 'CHANGE_CUSTOMER_PROJECT_TYPES':
            let dictionaryCustomerProjectType: DictionaryCustomerProject = {}
            const dictCustomerProjects = dictionaryComplexFromJsonArr(action.payload)
            for (const key in action.payload) {
                const element = action.payload[key]
                const currentOppElement = element.CustomerPTForOpportunityId ? dictCustomerProjects[element?.CustomerPTForOpportunityId] : element
                const currentProjectElement = element.CustomerPTForProjectId ? dictCustomerProjects[element?.CustomerPTForProjectId] : element
                const CustomerProjectStatusesByType: any = {}
                const dictionaryCustomerProjectStatus: ProjectStatusTypesParsed = {
                    allStatus: {},
                    opportunity: {},
                    project: {}
                }
                if (currentOppElement.CustomerProjectStatuses) {
                    for (const item of currentOppElement.CustomerProjectStatuses) {
                        if (item.projectTypeStatus === projectTypesInversed['opportunity']) {
                            if (!dictionaryCustomerProjectStatus['opportunity']) {
                                dictionaryCustomerProjectStatus['opportunity'] = {}
                            }
                            if (!CustomerProjectStatusesByType['opportunity']) {
                                CustomerProjectStatusesByType['opportunity'] = []
                            }
                            dictionaryCustomerProjectStatus['opportunity'][item.id] = item
                            dictionaryCustomerProjectStatus.allStatus[item.id] = item
                            CustomerProjectStatusesByType['opportunity'].push(item)
                        }
                    }
                }
                if (currentProjectElement.CustomerProjectStatuses) {
                    for (const item of currentProjectElement.CustomerProjectStatuses) {
                        if (item.projectTypeStatus === projectTypesInversed['project']) {
                            if (!dictionaryCustomerProjectStatus['project']) {
                                dictionaryCustomerProjectStatus['project'] = {}
                            }
                            if (!CustomerProjectStatusesByType['project']) {
                                CustomerProjectStatusesByType['project'] = []
                            }
                            dictionaryCustomerProjectStatus['project'][item.id] = item
                            dictionaryCustomerProjectStatus.allStatus[item.id] = item
                            CustomerProjectStatusesByType['project'].push(item)
                        }
                    }
                }
                dictionaryCustomerProjectType[element.id] = {
                    ...element,
                    customerProjectStatusDict: dictionaryCustomerProjectStatus,
                    CustomerProjectStatusesByType
                }
            }
            return state = dictionaryCustomerProjectType
        default:
            return state
    }
}